<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">


        <t-input v-model="form.machineId" hidden/>

        <b-row>

          <t-input v-model="form.name"  :add-error="error.name" cols="9" label="Descrição" required/>

          <t-input v-model="form.machineCodeLabel" v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                   :add-error="error.machineCodeLabel" upper cols="3"
                   label="Cód. Máquina"
                   code-label
                   help="Código inserido manualmente conforme configurado em Produção > Configurações > Parâmetros"
                   required/>

          <t-input v-model="form.machineCodeLabel"
                   v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                   :add-error="error.machineCodeLabel" upper cols="3"
                   fixed
                   label="Cód. Máquina"
                   help="Código inserido automaticamente conforme configurado em Produção > Configurações > Parâmetros"
          />



        </b-row>

        <t-input select :options="typeMachinesOptions" v-model="form.typeMachineId"
                 label="Tipo de Máquina" required/>


        <t-input select :options="operatorsOptions" v-model="form.operatorId"
                 label="Operador preferêncial"/>

        <b-row>

          <t-input v-model="form.serialNumber" cols="4" label="Nº Série"/>

          <t-input v-model="form.heritageNumber" cols="4" label="Nº Patrimônio"/>

          <t-input v-model="form.purchaseDate" date cols="4" label="Data Compra"/>

        </b-row>

        <t-page-form-field-customized
            ref="fieldsGeneral"
            :command="command" :status="status" :user-auth="userAuth"
            :fields-customizable="entityFieldCustomized('page')"
            :primary-key="form.lotId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
            :primary-key-column="fieldKey" foreign-key-column="pageId"
        />

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import typeMachineService from "@/services/modules/production/TypeMachine.service";
import operatorService from "@/services/modules/production/Operator.service";
import SettingType from "@/model/types/resource/SettingType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'MachineForm',
  data() {
    return {
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: true,
      fieldKey: "machineId",
      form: {
        machineId: 0,
        machineCodeLabel: "",
        typeMachineId: 0,
        operatorId: 0,
        name: "",
        serialNumber: "",
        heritageNumber: "",
        purchaseDate: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        machineCodeLabel: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      typeMachinesOptions: [],
      operatorsOptions: []
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await typeMachineService.selectList("").then((list) => {
        this.typeMachinesOptions = list
      }).catch(error => this.responseError(error))

      await operatorService.selectList("").then((list) => {
        this.operatorsOptions = list
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true


    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
